<template>
  <div class="container-fluid h-100" autofocus>
    <div class="row h-100">
      <div class="col">
        <div v-if="!start && !end" class="row h-100">
          <div
            class="h-100 col d-flex flex-column justify-center align-center"
            style="min-height:95vh;"
          >
            <div class="BoxStyle d-flex flex-column justify-center align-center">
              <h1 class="redText main-title pb-5 font-weight-regular display-2">
                88 enjoyable characters l<span style="text-transform:lowercase;">esson 2</span>
              </h1>

              <v-btn
                @click="letsgo"
                class="mb-3 mt-5"
                color="black BtnZoom"
                @mouseenter="buttonHover"
                dark
              >let's go</v-btn>
              <v-btn
                color="#888"
                dark
                @mouseenter="buttonHover"
                class="BtnZoom BtnBack mb-5"
                @click="GoToStartPage"
              >go back</v-btn>
            </div>
          </div>
        </div>
        <div class="row h-100" v-else-if="!end">
          <div
            class="col d-flex flex-column justify-center align-center h-100"
            :class="{'fade fade-in': true, 'fade-out':end, }"
            style="min-height:95vh;"
          >
            <!-- <v-btn @click="closeClick" icon class="d-none close-button">
              <v-icon size="40px" color="#F44336">mdi-close-circle</v-icon>
            </v-btn>-->
            <template v-for="(Question, i) in questions">
              <template v-if="questionIndex===i">
                <component
                  :key="i"
                  :is="Question"
                  :finish="finish"
                  :playSound="playSound"
                  :shuffle="shuffle"
                  :buttonHover="buttonHover"
                />
              </template>
            </template>
          </div>
        </div>
        <div v-if="end" class="row h-100">
          <div
            class="col d-flex align-items-center justify-content-center h-100"
            style="min-height:95vh;"
          >
            <div
              class="BoxStyle flex-column justify-start pt-3 align-center"
              style="padding-top: 105px !important;"
              :class="{'fade': true, 'fade-in':endEnable, }"
            >
              <h1
                class="red--text main-title"
                style="font-size: 3.75rem !important;"
              >Congratulations!</h1>
              <div class="text-center">
                <v-btn @click="restart" class="ml-3" color="black" dark>restart</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Question1 from "../components/lesson2/question1/Question1.vue";
import Question2 from "../components/lesson2/question2/Question2.vue";
import Question3 from "../components/lesson2/question3/Question3.vue";
import Question4 from "../components/lesson2/question4/Question4.vue";
import Question5 from "../components/lesson2/question5/Question5.vue";
import Question6 from "../components/lesson2/question6/Question6.vue";
import Question7 from "../components/lesson2/question7/Question7.vue";
import Question8 from "../components/lesson2/question8/Question8.vue";
import Question9 from "../components/lesson2/question9/Question9.vue";
import Vue from "vue"

export default {
  name: "MainPage",
  components: {
    Question1,
    Question2,
    Question3,
    Question4,
    Question5,
    Question6,
    Question7,
    Question8,
    Question9
  },
  data: () => ({
    questionIndex: 0,
    start: false,
    endEnable: false,
    end: false,
    questions: [
      Question1,
      Question2,
      Question3,
      Question4,
      Question5,
      Question6,
      Question7,
      Question8,
      Question9
    ]
  }),

  mounted() {
    this.click_letsgo = "/sound/click letsgo.wav";
    this.mouse_over = "/sound/new mouse over.wav";
    this.callAPI('https://www.chinesepod.com/api/v1/dashboard/get-info', "GET", {})
  },

  methods: {
    async callAPI(url, method, body){
      const headers = {
        'Content-Type': 'application/json',  
        'Authorization': `Bearer ${localStorage.getItem('vuex').token}` || '',
        'Access-Control-Allow-Origin': '*'
      }
      return await Vue.axios({
          method: method,
          url: `${url}`,
          data: body,
          headers: headers
      }).then((res) => {
          console.log(res);
          return  res;
          }).catch(err => err)
    },
    log(m) {
      console.log(...m);
    },
    finish() {
      if (this.questionIndex < this.questions.length - 1) {
        const title = document.getElementById("questionTitle");

        title.classList.toggle("fade-in");

        setTimeout(() => {
          title.innerHTML = "Nice!";
          title.style.marginRight = "6%";
          title.classList.toggle("fade-in");
        }, 1000);

        setTimeout(() => {
          this.questionIndex = this.questionIndex + 1;
        }, 2000);
      } else {
        setTimeout(() => {
          this.end = true;
          this.start = false;
          this.questionIndex = this.questionIndex + 1;
          setTimeout(() => {
            this.endEnable = true;
          }, 200);
        }, 1500);
      }
    },
    letsgo() {
      this.playSound(this.click_letsgo);
      this.start = true;
    },

    playSound(url) {
      return new Promise(function(resolve, reject) {
        // return a promise
        var audio = new Audio(); // create audio wo/ src
        audio.preload = "auto"; // intend to play through
        audio.autoplay = true; // autoplay when loaded
        audio.onerror = reject; // on error, reject
        audio.onended = resolve; // when done, resolve

        audio.src = url; // just for example
        audio.play();
      });
    },
    shuffle(array) {
      return array.sort(() => Math.random() - 0.5);
    },
    buttonHover() {
      console.log("d");
      this.playSound(this.mouse_over);
    },
    buttonClick() {
      this.playSound(this.mouse_over);
    },

    restart() {
      this.start = false;
      this.end = false;
      this.questionIndex = 0;
    },
    GoToMainPage() {
      this.buttonClick();
      this.$router.push("/");
    },
    GoToStartPage() {
      this.buttonClick();

      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
.x-btn {
  width: 70px;
  transition: transform 0.2s linear;
  &:hover {
    transform: scale(1.1);
  }
}
.wrong {
  width: 110px;
  height: 110px;
  position: absolute;
  background-size: cover;
  z-index: +99;
  background-image: url("../assets/img/sign.gif");
}
.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.text-box {
  border: 3px dashed #c00000;
  padding: 15px 25px;
  border-radius: 10px;
  background: #e7e6e6;
  font-size: 18px;
  width: 90%;
  margin: 0 auto;
  margin-top: 10px;

  p {
    white-space: pre-line;
  }
}

a {
  transition: all 0.2s ease !important;

  &.v-btn {
    height: 52px !important;
    min-width: 92px;
    padding: 0 23.1111111111px;
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    background-color: #000;
    border-color: #000;
  }

  &.v-btn:hover {
    transform: scale(1.1);
  }

  &.hint-btn:hover {
    margin: 0 -9px 0 3px !important;
  }
}
.btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height:95vh!important;
}

button {
  transition: all 0.2s ease !important;

  &.v-btn {
    height: 52px !important;
    min-width: 92px;
    padding: 0 23.1111111111px;
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    background-color: #000;
    border-color: #000;
  }

  &.v-btn:hover {
    transform: scale(1.1);
  }

  &.hint-btn:hover {
    margin: 0 -9px 0 3px !important;
  }
}

.close-button {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 20px;
  z-index: 1;
  top: 20px;
}

.close-text {
  position: absolute;
  right: 100px;
  top: 75px;
  border: 2px dashed #f44336;
  border-radius: 25px;
  background: #eee;
  z-index: 1;
}

.main-title {
  padding-left: 50px;
  font-weight: 400 !important;
  color: #a20017 !important;
  font-size: 2.125rem !important;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  margin-bottom: 50px;
  text-transform: uppercase;
  transition: all 0s ease;
  text-align: center;
}

.h-100 {
  height: 100% !important;
}

@keyframes Shower {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes _Shower {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.BoxStyle {
  box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.2),
    0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
  height: 500px;
  max-height: 500px;
  padding: 10px;
  display: flex;
  align-content: center;
  justify-content: center;
  animation-name: Shower;
  animation-duration: 1.6s;
  transition: all 0.6s;
  overflow: hidden;
  width: 1024px;
}

.BoxStyleRemove {
  animation-name: _Shower;
  animation-duration: 0.5s;
}

.BtnBack {
  background-color: #9e9e9e !important;
  border-color: #9e9e9e !important;
}

.HeaderPositionQuestion {
  top: 10px;
  padding-right: 20px !important;
  position: absolute;
  width: 100%;
  & .arrow {
    right: 80px;
    top: 65px;
    width: 50px;
    z-index: +9;
    height: 50px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets/img/red-sign.png");
  }
}

@media all and (max-width: 800px) {
  .options{
    .v-image{
      padding: 13px 10px;
      margin: 0 5px;
    }
    top: calc(64% - 150px) !important;
    .v-image__image{
      height: 90%;
    }
    &.image {
      &.active {
        & .v-image {
          border: 3px dashed #aaa !important;
          border-radius: 10px !important;
        }
        & .v-image__image {
          max-width: 190px;
          max-height: 190px;
        }
      }
    }
  }
  .HeaderPositionQuestion {
    & .arrow {
      right: 53px !important;
      top: 43px !important;
      height: 33px !important;
      width: 33px !important;
    }
  }
  .close-text{
    right: 73px !important;
    top: 48px !important;
  }
  .pa-5.close-text{
    padding: 5px !important;
  }
  .x-btn {
    width: 40px;
    position: absolute;
    right: 0px;
    top: 0;
  }
  .main-title{
    padding: 0;
    // text-align: start;
    font-size: 27px !important;
    width: 100%;
    position: relative;
    padding-right: 55px;
  }
  .BoxStyle {
    width: 100%;
  }
}

@keyframes closing {
  0% {
    top: 0%;
  }
  50% {
    top: 20%;
  }
  100% {
    top: 0%;
  }
}

.col-4 {
  flex: 0 0 33.3333333333% !important;
  max-width: 33.3333333333% !important;
}

.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  width: 100% !important;
  padding: 12px !important;
}

.HeaderPositionQuestion {
  top: 10px;
  padding-right: 20px !important;
  position: absolute;
  width: 100%;
  & .arrow {
    right: 80px;
    top: 65px;
    width: 50px;
    z-index: +9;
    height: 50px;
    position: absolute;
    background-size: cover;
    background-image: url("../assets/img/red-sign.png");
  }
}

.text-box {
  border: 3px dashed #c00000;
  padding: 15px 25px;
  border-radius: 10px;
  background: #e7e6e6;
  font-size: 18px;
  width: 90%;
  margin: 0 auto;
  margin-top: 10px;

  p {
    white-space: pre-line;
  }
}

.close-text {
  position: absolute;
  right: 100px;
  top: 75px;
  border: 2px dashed #f44336;
  border-radius: 25px;
  background: #eee;
  z-index: 1;
}

.main-title {
  padding-left: 50px;
  font-weight: 400 !important;
  color: #a20017 !important;
  font-size: 2.125rem !important;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  margin-bottom: 50px;
  text-transform: uppercase;
  transition: all 0s ease;
  text-align: center;
}

.options {
  padding: 40px 30px;
  border-radius: 20px;
  height: 276px;
  border-width: 3px !important;
  position: absolute;
  opacity: 1;
  transition-duration: 0.1s !important;
  transition: right 0.3s ease;
  top: calc(50% - 150px);
  .v-image__image {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    max-width: 196px;
    max-height: 196px;
  }
  .v-image {
    max-width: 250px;
    cursor: pointer;
    transition: left 0.5s ease;
    margin: auto;
    z-index: 1;
    padding: 20px 10px;
  }

  .scale {
    transform: scale(0);
    transition: all 1s ease;
    position: absolute;
    top: 2%;
    width: 90%;
    left: -39%;
  }

  &.image {
    &.active {
      /*padding: 10px !important;*/
      /*border: 2px dashed #aaa;*/
      & .v-image {
        border: 3px dashed #aaa !important;
        border-radius: 40px;
      }
      & .v-image__image {
        max-width: 190px;
        max-height: 190px;
      }
    }
  }

  &.clicked {
    right: 33.33% !important;

    + .index-1 {
      right: 0;
    }

    .scale {
      transform: scale(1);
    }
  }

  &.index-0 {
    transition-duration: 0.1s !important;
    transition: right 0.3s ease;
    right: 0;

    &.move-right {
      right: 166.66%;
    }
    &.move-left {
      right: -166.66%;
    }
  }

  &.index-1 {
    transition-duration: 0.1s !important;
    transition: right 0.3s ease;
    right: 33.33%;

    &.move-right {
      right: 166.66%;
    }

    &.move-left {
      right: -166.66%;
    }
  }

  &.index-2 {
    transition-duration: 0.1s !important;
    transition: right 0.3s ease;
    right: 66.66%;
    &.move-right {
      right: 120%;
    }
    &.move-left {
      right: -120%;
    }
  }
}

.RemoveControl .RemoveAnimation {
  transition: all 0.4s;
}

.h-100 {
  height: 100% !important;
}

.option-2 {
  .fork {
    position: absolute;
    top: 40%;
    left: 80%;
    width: 40%;
    opacity: 0;
    transition: all 1s ease;
  }

  .fork1 {
    top: 0;
    width: 30%;
    left: 85%;
    opacity: 0;
  }

  .v-image {
    left: 0;

    /*opacity: 0;*/
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;

      /*opacity: 0;*/
    }

    .fork {
      transition-delay: 4s;
      opacity: 1;
    }

    .fork1 {
      top: 10%;
      transition-delay: 6s;
      opacity: 1;
    }
  }
}

.option-3 {
  .part {
    position: absolute;
    top: 50%;
    left: 70%;
    width: 60%;
    opacity: 0;
    transition: all 1s ease;
  }

  .part1 {
    top: 15%;
    width: 60%;
    left: 70%;
    opacity: 0;
  }

  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }

    .part {
      transition-delay: 4s;
      opacity: 1;
    }

    .part1 {
      transition-delay: 4s;
      opacity: 1;
      animation: closing 2s ease 4s infinite;
    }
  }
}
// .wrong {
//   width: 110px;
//   height: 110px;
//   position: absolute;
//   background-size: cover;
//   z-index: +99;
//   background-image: url("/assets/img/sign.gif");
// }

.hints-row {
  position: relative;
  width: 100%;
  max-width: 1100px;
}

.options-row {
  width: 100%;
  max-width: 1100px;
  position: relative;
  min-height: 320px;
}
</style>
